/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { SvgIcon } from '@mui/material';

export function SupportIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return (
    <SvgIcon {...props}>
      <path d="M19.79,15.41 C20.74,13.24 20.74,10.75 19.79,8.59 L17.05,9.83 C17.65,11.21 17.65,12.78 17.06,14.17 L19.79,15.41 M15.42,4.21 C13.25,3.26 10.76,3.26 8.59,4.21 L9.83,6.94 C11.22,6.35 12.79,6.35 14.18,6.95 L15.42,4.21 M4.21,8.58 C3.26,10.76 3.26,13.24 4.21,15.42 L6.95,14.17 C6.35,12.79 6.35,11.21 6.95,9.82 L4.21,8.58 M8.59,19.79 C10.76,20.74 13.25,20.74 15.42,19.78 L14.18,17.05 C12.8,17.65 11.22,17.65 9.84,17.06 L8.59,19.79 M12,2 C14.6521649,2 17.195704,3.0535684 19.0710678,4.92893219 C20.9464316,6.80429597 22,9.3478351 22,12 C22,17.5228475 17.5228475,22 12,22 C9.3478351,22 6.80429597,20.9464316 4.92893219,19.0710678 C3.0535684,17.195704 2,14.6521649 2,12 C2,9.3478351 3.0535684,6.80429597 4.92893219,4.92893219 C6.80429597,3.0535684 9.3478351,2 12,2 M12,8 C9.790861,8 8,9.790861 8,12 C8,14.209139 9.790861,16 12,16 C14.209139,16 16,14.209139 16,12 C16,9.790861 14.209139,8 12,8 Z" />
    </SvgIcon>
  );
}
